module.exports = __webpack_public_path__ + "static/media/compliance_subbanner2.0d54bda9.png";